/* eslint-disable max-len */
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AccessGuard } from './ui/access.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule), canActivate: [AccessGuard]
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./ui/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'usuario',
    loadChildren: () => import('./ui/usuario/usuario.module').then(m => m.UsuarioPageModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./ui/menu/menu.module').then(m => m.MenuPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'navtabs',
    loadChildren: () => import('./ui/navtabs/navtabs.module').then(m => m.NavtabsPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'veiculo',
    loadChildren: () => import('./ui/veiculo/veiculo.module').then(m => m.VeiculoPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'listaveiculo',
    loadChildren: () => import('./ui/listaveiculo/listaveiculo.module').then(m => m.ListaveiculoPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'requisicao',
    loadChildren: () => import('./ui/requisicao/requisicao.module').then(m => m.RequisicaoPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'listarequisicao',
    loadChildren: () => import('./ui/listarequisicao/listarequisicao.module').then(m => m.ListarequisicaoPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'veiculo',
    loadChildren: () => import('./ui/veiculo/veiculo.module').then(m => m.VeiculoPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'listaveiculo',
    loadChildren: () => import('./ui/listaveiculo/listaveiculo.module').then(m => m.ListaveiculoPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'ocorrencia',
    loadChildren: () => import('./ui/ocorrencia/ocorrencia.module').then(m => m.OcorrenciaPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'listaocorrencia',
    loadChildren: () => import('./ui/listaocorrencia/listaocorrencia.module').then(m => m.ListaocorrenciaPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'listacredito',
    loadChildren: () => import('./ui/listacredito/listacredito.module').then(m => m.ListacreditoPageModule), canActivate: [AccessGuard]
  },
  {
    path: 'validausuario',
    loadChildren: () => import('./ui/validausuario/validausuario.module').then(m => m.ValidausuarioPageModule)
  },
  {
    path: 'info',
    loadChildren: () => import('./ui/info/info.module').then(m => m.InfoPageModule)
  },
  {
    path: 'pagamento',
    loadChildren: () => import('./ui/pagamento/pagamento.module').then(m => m.PagamentoPageModule), canActivate: [AccessGuard]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
